<template>
  <div class="alert alert-danger d-flex flex-column align-items-start" role="alert">
    <div class="d-flex align-items-center mb-2">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      <strong>{{ title }}</strong>
    </div>
    <p class="mb-2 error-text">{{ message }}</p>
    <button
      v-if="retryable"
      class="btn btn-sm btn-outline-danger"
      @click="$emit('retry')"
    >
      <i class="bi bi-arrow-clockwise ms-1"></i> تلاش مجدد
    </button>
  </div>
</template>

<script lang="ts">
export default {
  name: "ErrorMessage",
  props: {
    title: {
      type: String,
      default: "مشکلی پیش آمد",
    },
    message: {
      type: String,
      default: "خطای غیرمنتظره‌ای رخ داد.",
    },
    retryable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["retry"],
};
</script>

<style scoped>
.error-text {
  white-space: pre-line;
}
</style>
